import { coreApi } from "../../app/core-api";
import { EntityCreateResult, PagedResult, PagedSearchFilter } from "../../app/types";
import {
    AttendanceDevice,
    AttendanceDeviceRegisterRequest,
    AttendanceLog,
    AttendanceLogFileDto,
    AttendanceLogFilter,
    AttendanceLogsFailedRetryResult,
    DeviceSyncResult,
    DeviceUser,
    DeviceUserSyncDto,
} from "./attendance.types";

export const attendanceApi = {
    searchLogs,
    processFailedLogs,
    searchAllDevices,
    searchDevices,
    getDevice,
    registerDevice,
    updateDevice,
    deleteDevice,
    getDeviceUsers,
    addDeviceUsers,
    checkDeviceStatus,
    uploadDeviceLogs,
    backupDeviceBiometriEnrollments,
};

const controller = "attendance";

function searchLogs(filter: PagedSearchFilter<AttendanceLogFilter>) {
    return coreApi.get<PagedResult<AttendanceLog>>(`${controller}/logs`, { ...filter.filter, ...filter.pagination });
}

function processFailedLogs() {
    return coreApi.post<AttendanceLogsFailedRetryResult>(`${controller}/logs/process-failed`, {});
}

function searchAllDevices() {
    return coreApi.get<AttendanceDevice[]>(`${controller}/devices/all`);
}

function searchDevices() {
    return coreApi.get<AttendanceDevice[]>(`${controller}/devices`);
}

function getDevice(id: string) {
    return coreApi.get<AttendanceDevice>(`${controller}/devices/${id}`);
}

function registerDevice(device: AttendanceDeviceRegisterRequest) {
    return coreApi.post<EntityCreateResult>(`${controller}/devices`, device);
}

function updateDevice(id: string, device: AttendanceDeviceRegisterRequest) {
    return coreApi.put(`${controller}/devices/${id}`, device);
}

function deleteDevice(id: string) {
    return coreApi.remove(`${controller}/devices/${id}`);
}

function getDeviceUsers(id: string) {
    return coreApi.get<DeviceUser[]>(`${controller}/devices/${id}/users`);
}

function addDeviceUsers(id: string, users: DeviceUserSyncDto[]) {
    return coreApi.post<DeviceSyncResult>(`${controller}/devices/${id}/users`, users);
}

function checkDeviceStatus(id: string) {
    return coreApi.post(`${controller}/devices/${id}/check-status`, {});
}

function backupDeviceBiometriEnrollments(id: string) {
    return coreApi.post(`${controller}/devices/${id}/backup-enrollment-data`, {});
}

function uploadDeviceLogs(file: AttendanceLogFileDto) {
    return coreApi.post(`${controller}/devices/logs/upload`, file);
}
